export const cloudinaryWeddingPhotos = [
  {
    publicId: "weddings/ul0q3wjbkcqrqwtgrqvu",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/szxv0rxhnhloimotamf9",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/c0ha6ip2h2fvpbonanil",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/hhjoprtesf1xd7cvjitz",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/jxutkhmkmnbghzdfpqz4",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/s3cpy6quh3uls34u4j7c",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/amujyogetspbofxr3gob",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/hjevx35v3j9sgbxlztb0",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/v3qoz2p8b1dvr43tmhtj",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/yqpske3gyre6n6nvrbz3",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/udgha15l7um5vb7tr50p",
    height: 1320,
    width: 881,
  },

  {
    publicId: "weddings/claxl6l91rv3zb0gz86e",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/gdxtpn71iy4wo1snkp9l",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/tm1fzzxum2vkwby5c07o",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/ynft7cmwgnrshctbxbnj",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/huxctznmw1mxfofhbzoz",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/i9fhajptxo6z8pklbrao",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/zxpqyuu7nwhckqdwx6xq",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/zmjudz5fdmhrwg9ekei5",
    width: 1320,
    height: 881,
  },

  {
    publicId: "weddings/yimf4rrqxrwmapmhjegi",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/g770zlmmtylct8u8uvmj",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/lgnrufun0qkusfnvzl3q",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/b3etjr6ekezi24slhh8g",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/ccvghgxbgrvjniwwvn0e",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/jnakcxwu8ybbssmmztlg",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/zjozpkmm6bpwylyp4pyr",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/efqkd7ju7r9aytmhvmzr",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/qbahw67t2x7t8xal96eb",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/ldf0ufvbyfumgwbxlobw",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/ycsb3kn7ws9pwa3qjz4l",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/ocwhaa2o4ms3kzrbf4s4",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/sggjjxfwdwcnnrfoympi",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/rzznz6pau4gfpvcuhejg",
    width: 1320,
    height: 881,
  },

  {
    publicId: "weddings/km9adwjtpbjobexb2cii",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/myhzdkyeinyqxpltmnmp",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/u6deglgc5ice5k8gr6to",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/b34lp0h5pmqd2nkslpya",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/euhwjygzgv96ykaeyjqn",
    height: 1320,
    width: 881,
  },

  {
    publicId: "weddings/ockwfqhuqocza9g5to8n",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/hzld0ezqtwmlac0h6ztz",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/rwutdxzqljzqob2isx4n",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/mmlshv3unplstjae1wh9",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/qlapupx4vc3ecumassbi",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/ne6kzqo2bnmy1pjvk64u",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/m5bqncrka5rmd9sesee2",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/fubpoebpeqdchtjnc2ph",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/km0fsjhjeop50n2odq9t",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/axhyz4tqklmjs15imovp",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/gkszpn1rdkbgq1pgzmga",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/mzmmy3k1wbrctf5okui3",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/nt4dxpgdjdhsvgnrushr",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/rcmxv0cjbzn8ijtqrqxj",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/f3euypkmkes4fehasptv",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/yizzl2g3qzhmfnkuareg",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/cj2ztr7orbqxj7koajak",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/uv1lm1vu3sjlip2wvd0l",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/yztaqmuiurcpttysxlak",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/acjtegldgc8x21ub2ba3",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/jbymvjipjlawkn8encwd",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/cx872zyosta6rpxjov5x",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/bziymkgrcfvouvtwhkmk",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/krainmix3idwciofrgyd",
    height: 1320,
    width: 881,
  },

  {
    publicId: "weddings/w6c3iu4i3c60f57koqmg",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/m1ivguoxe7u5bwufedjq",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/bmhvbkqwestfaaneabpy",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/vldcudgq0tu8udgbvf2e",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/jq5sxtyozgxc5vffga4f",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/xwmppyy9dnlx7sr2rqc3",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/oeqzsgbi625it2pipjog",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/mpnoodjausxpnabtg12k",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/jaucopdffovvgomd67s9",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/fpxvxdwqobt9vx77fkaz",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/toiocwcxzd5sniq4mwby",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/h5bofnaulwkred2pbkms",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/rn5kftwhhaphclyrwbif",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/rqnvbw0bv5nnn1at6ptw",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/mx31xbegdtthwiw6yxlc",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/q0xo5gr4qpoh0y6amgir",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/tfbar2hrj3ke1vwf11xy",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/wi96ybmorrhfsivlhbit",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/zfgkzyr62vi1fgq5gwdu",
    width: 1320,
    height: 1056,
  },
  {
    publicId: "weddings/djopr2ankpa1fec0ucke",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/hwhujq0egxpgufkbc55z",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/cf8efahep22a3llrdxlk",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/flk5uv5bnhvuhtinrkkd",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/b33y2qe4mogzvng3bnzt",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/mnw0xo9yyrwxsdkpknqb",
    width: 1320,
    height: 881,
  },

  {
    publicId: "weddings/yp9tlnkp8jsjwa699g52",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/wakakzorei862aruttbh",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/vbtmbcwoemxztozv55d0",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/lygtzon7tg36wfn0z7nb",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/b9mwmjzskh9kznnbcil2",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/qfyc18cwlt2tsrv5dhe1",
    width: 1320,
    height: 881,
  },
  {
    publicId: "weddings/rhiv2ctpxkgmghs9umfx",
    height: 1320,
    width: 881,
  },
  {
    publicId: "weddings/regpzhtr67kfuvghbcd6",
    width: 1320,
    height: 881,
  },
];
